import React from 'react'
function Contact(props) {
  //const featuredImage = 'https://discover.af-pictures.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';
const featuredImage = '/static/trans.gif';

  return (
    <section id="contacto" className={props.transition}>



    <div className="mx-auto">
              <h1 style={{fontSize:'300%'}} className="text-center w-full text-8xl text-white">CONTACTO</h1>


        <div className="mx-6 mt-16">
          <p className="text-center  w-full">
              <svg style={{margin:'0 auto'}} xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 mx-2 mb-4 branding-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>

              <span className="mx-2 pt-2 text-white font-medium">
              Calle Alcalá, N. 126, 28009, Madrid, España
              </span>
          </p>

            <p className="text-center w-full pt-6">
                <svg style={{margin:'0 auto'}} xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 mx-2 mb-4 branding-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>

                <span className="mx-2 pt-2 text-white font-medium"><a href="mailto:info@afpictures.com">info@afpictures.com</a></span>
            </p>

        </div>
      </div>





</section>
  )
}

export default Contact
